import { createApp } from 'vue'
import { createStore } from 'vuex'
import modules from './modules/modules'
import getters from './getters'

const app = createApp({})

app.use(createStore)

export default createStore({
  modules,
  getters,
  state: {},
  mutations: {},
  strict: true,
})
